var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-row justify-content-between pt-1" },
    [
      _c("div", { staticClass: "col-9" }, [
        _c("div", [
          _c("h3", {
            staticClass: "mb-0 text-primary3",
            class: _vm.getWrapper("title-wrapper"),
            domProps: { textContent: _vm._s(_vm.offerName) },
          }),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { class: _vm.getWrapper("price-wrapper") },
            [
              _c("price", {
                attrs: {
                  price: _vm.price.priceInCents,
                  "initial-price": _vm.price.initialPriceInCents,
                  "show-by-month": _vm.price.showByMonth,
                  "show-from": _vm.price.showFrom,
                  duration: _vm.price.duration,
                  "price-details": _vm.price.priceDetails,
                  "price-label": _vm.price.priceLabel,
                  "show-promo-duration": _vm.showPromoDuration,
                  "show-end-of-promotion-price": _vm.showEndOfPromotionPrice,
                  "show-until-end-of-promo": _vm.showUntilEndOfPromo,
                  "show-children-promotion-price":
                    _vm.showChildrenPromotionPrice,
                  "show-promo-duration-first-months":
                    _vm.showPromoDurationFirstMonths,
                  "is-mini": true,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            { class: _vm.getWrapper("link-wrapper") },
            [
              _c("Lien", {
                attrs: {
                  href: _vm.detailLink.url,
                  label: _vm.detailLink.label,
                  "is-link-arrow": true,
                  "tms-category": _vm.detailLink.tms.category,
                  "tms-action": _vm.detailLink.tms.action,
                  "tms-label": _vm.detailLink.tms.label,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          staticClass: "offer-visual",
          attrs: { src: _vm.visual.url, alt: _vm.visual.alt },
        }),
        _vm._v(" "),
        _vm.backgroundVisual
          ? _c("img", {
              staticClass: "offer-visual-bg",
              attrs: {
                src: _vm.backgroundVisual.url,
                alt: _vm.backgroundVisual.alt,
              },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }